import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import metadata from './MLCarcoComponent.metadata.json5'

function MLCarcoComponent(props) {
    const {
        inspectionVM,
        onValidate
    } = props

    const { refreshData } = useDataRefresh();

    const overrides={}

    const resolvers={}

    const handleValueChange=(value,path)=>{
        _.set(inspectionVM, path, value);
        refreshData();
    }


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={inspectionVM}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
        />
    );
}

MLCarcoComponent.propTypes = {
    inspectionVM: PropTypes.shape({}).isRequired,
    onValidate: PropTypes.func.isRequired
}

export default MLCarcoComponent;